export default __webpack_public_path__ + "static/media/antonio_ayala.62867d25.png";